// ***************************************
// gameSettings
//
// This function returns the settings for the game.
// It is used in the constructor for the game controller.
//
// This version is just a template.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 12-10-2015
// ***************************************
export var gameSettings = function () {
    "use strict";
    return {
        // Required game related settings
        game: {
            name: "<UNKNOWN>",
            id: "<UNKNOWN>",
            version: "1.0",
            documentTitle: "Game Template",
            hasModes: false,
            modeIds: [0, 1, 2],
            modeKeys: ["Easy", "Medium", "Difficult"],
            hasLevels: true,
            levelsUnlocked: false,
            levelCount: 9,
            worldLevelCounts: [9],
            worldLevelKeys: ["World1"],
            hasStars: true,
            scoreType: "numberUp",
            scorePerLevel: true,
            scorePerMode: false,
            // TODO: add achievements
            tutorialData: [],
            dummy: null // To avoid problems with missing comma
        },
        // Specific flow settings that override the default flow settings
        flow: {}
    };
};
